import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import Root from "./Root";

const { MODE } = import.meta.env;

if (MODE === "production") {
    Sentry.init({
        dsn: "https://ce0f24069ea44c11bcf2916664c6b65b@bugsink.dev-promo.ru/15",
        integrations: [],
        debug: true,
        denyUrls: [],
        allowUrls: [window.location.origin, /ris\.promo/],
        sampleRate: 0.05,
    });
}

createRoot(document.getElementById("root")).render(<Root />);
